var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["page"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import Url from "url-parse";
import queryString from "query-string";
import { ArrowLightIcon } from "@riseart/icons";
import { arrayRange } from "@riseart/fe-utils";
import { Link } from "../link/Link";
import { paginationCls, paginationItemCls, paginationItemActiveCls, paginationItemDisabledCls, paginationItemLinkCls, paginationNextCls, paginationPrevCls, paginationJumpCls, showForLargeCls, showForXlargeCls, hideForSmallCls } from "./Slider.less";
var itemRenderer = /* @__PURE__ */ __name(function itemRenderer2(baseUrl, translations, urlAssembler) {
  var parsedUrl = new Url(baseUrl);
  var _queryString$parse = queryString.parse(parsedUrl.query), currentPage = _queryString$parse.page, parsedQueryString = _objectWithoutProperties(_queryString$parse, _excluded);
  return function(page, type) {
    var disabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var combinedSearchParams = _objectSpread(_objectSpread({}, parsedQueryString), page > 1 ? {
      page
    } : null);
    var search = urlAssembler ? urlAssembler.mergeOptions({
      search: combinedSearchParams
    }).search : "?".concat(queryString.stringify(combinedSearchParams));
    var url = "".concat(parsedUrl.pathname).concat(search).concat(parsedUrl.hash || "");
    switch (type) {
      case "page": {
        return /* @__PURE__ */ React.createElement(Link, {
          to: url,
          title: "".concat(translations.page, " ").concat(page),
          className: paginationItemLinkCls,
          disabled
        }, page);
      }
      case "prev": {
        return /* @__PURE__ */ React.createElement(Link, {
          to: url,
          title: translations.previous,
          className: paginationItemLinkCls,
          disabled
        }, /* @__PURE__ */ React.createElement(ArrowLightIcon, null));
      }
      case "next": {
        return /* @__PURE__ */ React.createElement(Link, {
          to: url,
          title: translations.next,
          className: paginationItemLinkCls,
          disabled
        }, /* @__PURE__ */ React.createElement(ArrowLightIcon, null));
      }
      default: {
        return null;
      }
    }
  };
}, "itemRenderer");
function SliderPagination(_ref) {
  var totalPages = _ref.totalPages, defaultCurrent = _ref.defaultCurrent, _ref$current = _ref.current, current = _ref$current === void 0 ? 0 : _ref$current, baseUrl = _ref.baseUrl, customItemRenderer = _ref.itemRenderer, _ref$translations = _ref.translations, translations = _ref$translations === void 0 ? {
    page: "",
    next: "",
    previous: ""
  } : _ref$translations, urlAssembler = _ref.urlAssembler, onChange = _ref.onChange;
  var RANGE_SPLIT = 3;
  var PAGE_SECTION_COUNT = 5;
  var mountRef = useRef(false);
  var renderer = typeof customItemRenderer === "function" ? customItemRenderer : itemRenderer(baseUrl, translations, urlAssembler);
  var currentPage = current || defaultCurrent || 1;
  var prevPage = currentPage > 1 ? currentPage - 1 : 0;
  var nextPage = currentPage < totalPages ? currentPage + 1 : totalPages;
  var currentPageTens = Math.ceil(currentPage / 10);
  useEffect(function() {
    if (mountRef.current && typeof onChange === "function") {
      onChange(currentPage);
    }
    mountRef.current = true;
  }, [currentPage, onChange]);
  var separatedPages = {
    first: {
      position: 1,
      items: []
    },
    firstSection: {
      position: 2,
      items: [],
      classNames: [showForLargeCls, showForXlargeCls]
    },
    middle: {
      position: 4,
      items: []
    },
    secondSection: {
      position: 3,
      items: [],
      classNames: [showForLargeCls, showForXlargeCls]
    },
    last: {
      position: 5,
      items: []
    }
  };
  separatedPages.first.items = currentPage < PAGE_SECTION_COUNT || totalPages <= PAGE_SECTION_COUNT ? arrayRange(1, totalPages > PAGE_SECTION_COUNT ? PAGE_SECTION_COUNT : totalPages, 1) : [1];
  separatedPages.middle.items = currentPage > PAGE_SECTION_COUNT - 1 && currentPage <= totalPages - PAGE_SECTION_COUNT + 1 ? arrayRange(currentPage - RANGE_SPLIT + 1, currentPage + RANGE_SPLIT - 1) : [];
  separatedPages.first.items = separatedPages.first.items.filter(function(pageNumber) {
    return separatedPages.middle.items.indexOf(pageNumber) === -1;
  });
  if (totalPages > PAGE_SECTION_COUNT) {
    separatedPages.last.items = currentPage > totalPages - PAGE_SECTION_COUNT + 1 ? arrayRange(totalPages - PAGE_SECTION_COUNT + 1, totalPages, 1) : [totalPages];
    separatedPages.last.items = separatedPages.last.items.filter(function(pageNumber) {
      return separatedPages.middle.items.indexOf(pageNumber) === -1 && separatedPages.first.items.indexOf(pageNumber) === -1;
    });
    if (separatedPages.last.items.length < PAGE_SECTION_COUNT) {
      separatedPages.last.items = separatedPages.last.items.slice(-1);
    }
  }
  if (currentPageTens > 1) {
    separatedPages.firstSection.items = arrayRange((currentPageTens - RANGE_SPLIT - 1) * 10, currentPageTens * 10, 10).filter(function(pageNumber) {
      return pageNumber > 0 && pageNumber < currentPage && separatedPages.middle.items.indexOf(pageNumber) === -1 && separatedPages.last.items.indexOf(pageNumber) === -1;
    }).slice(-3);
  }
  if (currentPageTens * 10 < totalPages - PAGE_SECTION_COUNT) {
    separatedPages.secondSection.items = arrayRange(currentPageTens * 10, (currentPageTens + RANGE_SPLIT) * 10, 10).filter(function(pageNumber) {
      return pageNumber > currentPage && pageNumber < totalPages && separatedPages.middle.items.indexOf(pageNumber) === -1 && separatedPages.last.items.indexOf(pageNumber) === -1;
    }).slice(0, 3);
  }
  return /* @__PURE__ */ React.createElement("ul", {
    className: paginationCls
  }, /* @__PURE__ */ React.createElement("li", {
    key: "prev",
    className: classNames(paginationPrevCls, currentPage <= 1 && paginationItemDisabledCls)
  }, renderer(prevPage, "prev", currentPage <= 1)), Object.keys(separatedPages).sort(function(a, b) {
    return separatedPages[a].position > separatedPages[b].position;
  }).map(function(key, index) {
    var _separatedPages$key = separatedPages[key], pageSection = _separatedPages$key.items, sectionClassNames = _separatedPages$key.classNames;
    var totalPagesInSection = pageSection.length;
    if (!pageSection || !pageSection.length) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, {
      key
    }, index ? /* @__PURE__ */ React.createElement("li", {
      key,
      className: classNames(paginationItemCls, paginationJumpCls, sectionClassNames)
    }) : null, pageSection.map(function(page, sectionPageIndex) {
      return /* @__PURE__ */ React.createElement("li", {
        key: page,
        className: classNames(paginationItemCls, "".concat(paginationItemCls, "-").concat(page), currentPage === page && paginationItemActiveCls, sectionClassNames, ["middle"].indexOf(key) > -1 && totalPagesInSection >= PAGE_SECTION_COUNT && (sectionPageIndex === 0 || sectionPageIndex === totalPagesInSection - 1) && hideForSmallCls)
      }, renderer(page, "page"));
    }));
  }), /* @__PURE__ */ React.createElement("li", {
    key: "next",
    className: classNames(paginationNextCls, currentPage >= totalPages && paginationItemDisabledCls)
  }, renderer(nextPage, "next", currentPage >= totalPages)));
}
__name(SliderPagination, "SliderPagination");
export {
  SliderPagination
};
